import { CheckCircleIcon } from '@heroicons/react/24/outline';

interface NotificationsAllReviewedProps {
    // Each is absent when the host has nowhere to send the user.
    onNextPatient?: () => void;
    onBackToList?: () => void;
}

export function NotificationsAllReviewed({
    onNextPatient,
    onBackToList
}: NotificationsAllReviewedProps) {
    return (
        <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6 py-10 text-center">
            <div className="grid h-10 w-10 place-items-center rounded-full border border-gray-200 bg-white text-teal-600">
                <CheckCircleIcon aria-hidden="true" className="h-5 w-5" />
            </div>
            <div className="flex flex-col gap-1">
                <h3 className="text-[13.5px] font-semibold text-gray-800">All caught up</h3>
                <p className="text-[12.5px] text-gray-500">
                    No open DM notifications for this patient.
                </p>
            </div>
            {(onNextPatient || onBackToList) && (
                <div className="flex flex-wrap items-center justify-center gap-2">
                    {onNextPatient && (
                        <button
                            type="button"
                            onClick={onNextPatient}
                            className="rounded-lg bg-gray-900 px-4 py-2 text-[13px] font-medium text-white transition-colors hover:bg-gray-800"
                        >
                            Next patient
                        </button>
                    )}
                    {onBackToList && (
                        <button
                            type="button"
                            onClick={onBackToList}
                            className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-[13px] font-medium text-gray-700 transition-colors hover:bg-gray-50"
                        >
                            Back to list
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}
